const KeenSlider = window.KeenSlider

const { getOffsetTop } = window.BAO.Utils
const { setInitialised } = window.BAO.Carousel.plugins

class GalleryCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 'auto',
          spacing: 0,
        },
        detailsChanged: (instance) => {
          const maxDistance = 50
          const maxOpacity = 0.5

          const firstSlideProgress =
            1 - instance.track.details.slides[0].portion

          const heroTransform =
            maxDistance * firstSlideProgress < 0
              ? 0
              : maxDistance * firstSlideProgress
          const heroOpacity =
            maxOpacity * firstSlideProgress < 0
              ? 0
              : maxOpacity * firstSlideProgress

          this.els.hero.element.style.setProperty(
            '--Transform_Amount',
            `-${heroTransform}%`,
          )
          this.els.hero.element.style.setProperty(
            '--Overlay_Opacity',
            heroOpacity.toFixed(2),
          )
        },
      },
      [setInitialised()],
    )
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setOverlayOpacity()
  }

  setOverlayOpacity () {
    if (!this.offsetHeight) return

    const maxOpacity = 0.9

    const elementStartPoint = getOffsetTop(this)
    const elementEndPoint = elementStartPoint + window.innerHeight

    if (this.lastKnownY <= elementStartPoint) {
      this.els.mobilemedia.element.style.setProperty('--Hero_Opacity', 1)

      return
    }

    if (this.lastKnownY > elementEndPoint) {
      this.els.mobilemedia.element.style.setProperty(
        '--Hero_Opacity',
        1 - maxOpacity,
      )

      return
    }

    const totalScrollAmount = elementEndPoint - elementStartPoint

    const scrollYAsAPercentageOfJourney =
      (this.lastKnownY - elementStartPoint) / totalScrollAmount

    const opacityAmount = 1 - maxOpacity * scrollYAsAPercentageOfJourney

    this.els.mobilemedia.element.style.setProperty(
      '--Hero_Opacity',
      opacityAmount,
    )
  }
}

if (!customElements.get('gallery-carousel')) {
  customElements.define('gallery-carousel', GalleryCarousel)
}
